<div class="row app-search-model">
    <div class="col-sm-12">
        <mat-form-field class="w-100">
            <mat-label>Modèle</mat-label>
            <input matInput type="text" [formControl]="searchControl">
        </mat-form-field>
        <div class="result" *ngIf="result; else helperSearchModel">
            <span class="price">Prix estimé : <span class="estimate-price">{{ result.average_price }}</span> €</span>
            &nbsp;
            <small class="based-on">Basé sur {{ result.based_on }} vente(s)</small>
        </div>
        <ng-template #helperSearchModel>
            <div class="helper-search-model" *ngIf="!isLoading; else loadingPrice">
                Pour rechercher un modèle : entrer la marque et le modèle dans le champ de recherche
            </div>
        </ng-template>
        <ng-template #loadingPrice>
            <app-spinner [text]="loadingPriceTxt"></app-spinner>
        </ng-template>

        <button class="submit-btn mt-3" mat-flat-button [disabled]="isLoading" (click)="onSubmit()">Recherche</button>
    </div>
</div>